import React, { useEffect, useState, useContext, useCallback } from 'react';
import Card from '../Common/CourseCard';
import PageLayout from '../Layouts/PageLayout';
import { getAuthDataCall, getDataCall } from '../../components/services/utils';
import { withRouter, useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../Common/Loader';
import Select from 'react-select';
import { UserContext } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ReactModal from 'react-modal';
import SelectCountryModal from '../modals/SelectCountryModal';
import { useModal } from 'react-modal-hook';
import { usePageTitle } from '../../hooks/usePageTitle';


function AllCourses(props) {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    usePageTitle('Courses')

    const options = [
        { value: 'low', label: t('course.priceLowToHigh', 'Price low to high') },
        { value: 'high', label: t('course.priceHighToLow', 'Price high to low') },
    ];

    const type = props.match.params.type;
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [tags, setTags] = useState([]);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [nextPage, setNextPage] = useState('');
    const [priceFilter, setPriceFilter] = useState();
    const [tag, setTag] = useState(0);
    const { user, loggedIn, loadingUser } = useContext(UserContext);
    const userCountry = useSelector((state) => state.unauthedUserInfo.country);
    const [show, setShow] = useState(false);
    const [searchInstructor, setSearchInstrcutor] = useState([]);
    const [instructors, setInstructors] = useState([]);

    const [openSelectCountryModal, closeSelectCountryModal] = useModal(() => {
        setShow(true);
        return (
            <ReactModal isOpen ariaHideApp={false} className="react_modal" overlayClassName="modal_overlay">
                <SelectCountryModal closeModal={closeSelectCountryModal} setRecCourses={setData} setShow={setShow} />
            </ReactModal>
        );
    });

    useEffect(() => {
        if (!loggedIn && userCountry === null) {
            openSelectCountryModal();
        }
    }, [loggedIn, userCountry, openSelectCountryModal]);

    // browse category courses
    const getCourseByCategory = useCallback(
        async (url) => {
            setLoading(true);
            const resp = loggedIn ? await getAuthDataCall(url) : await getDataCall(url);
            if (resp.success) {
                setNextPage(resp.data.next_page_url);
                setHasNextPage(true);
                setLoading(false);
                setData(resp.data.data);
            }
            if (resp.data.current_page === resp.data.last_page) {
                setHasNextPage(false);
                return;
            }
        },
        [loggedIn]
    );

    const getTags = useCallback(async (url) => {
        setLoading(true);
        const resp = await getDataCall(url);
        if (resp.success) {
            setTags(resp.data);
        }
        setLoading(false);
    }, []);

    async function fetchCourseData() {
        let resp = loggedIn ? await getAuthDataCall(nextPage) : await getDataCall(nextPage);
        if (resp.success) {
            setNextPage(resp.data.next_page_url);
            setData((prevData) => [...prevData, ...resp.data.data]);
            setHasNextPage(true);
        }

        if (resp.data.current_page === resp.data.last_page) {
            setHasNextPage(false);
            return;
        }
    }

    // all course
    const getAllCourses = useCallback(
        async (url) => {
            setTag(0);
            setLoading(true);
            const resp = loggedIn ? await getAuthDataCall(url) : await getDataCall(url);

            if (resp.success) {
                setNextPage(resp.data.next_page_url);
                setLoading(false);
                setData(resp.data.data);
                setSearchInstrcutor(resp.data.data);
                getAllInstructors(resp.data.data);
                setHasNextPage(true);
            }
            if (resp.data.current_page === resp.data.last_page) {
                setHasNextPage(false);
                return;
            }
        },
        [loggedIn]
    );

    function getAllInstructors(courses) {
        const instructorSet = new Set();
        const newInstructors = [];

        courses?.forEach((course) => {
            course?.instructors?.forEach((instructor) => {
                if (!instructorSet.has(instructor.id)) {
                    instructorSet.add(instructor.id);
                    newInstructors.push({
                        value: instructor.id,
                        label: `${instructor.first_name} ${instructor.last_name}`,
                    });
                }
            });
        });
        setInstructors(newInstructors); // set the new state once
    }

    async function fetchData() {
        let resp = loggedIn ? await getAuthDataCall(nextPage) : await getDataCall(nextPage);
        if (resp.success) {
            setNextPage(resp.data.next_page_url);
            setData((prevData) => [...prevData, ...resp.data.data]);
            setHasNextPage(true);
        }
        if (resp.data.current_page === resp.data.last_page) {
            setHasNextPage(false);
            return;
        }
    }

    // filter data
    const getFilterData = useCallback(
        async (filter, tag) => {
            setTag(tag);
            setLoading(true);
            // Added null/optional chaining check for userCountry for safety
            const countryId = userCountry?.id;
            const url = `v1/courses?${filter}&country_id=${countryId}`;
            const resp = loggedIn ? await getAuthDataCall(url) : await getDataCall(url);
            if (resp.success) {
                setNextPage(resp.data.next_page_url);
                setLoading(false);
                setData(resp.data.data);
            }
            if (resp.data.current_page === resp.data.last_page) {
                setHasNextPage(false);
                return;
            }
        },
        [loggedIn, userCountry]
    );

    // filter by price
    const getFilterDataBYPrice = useCallback(
        async (filter) => {
            setLoading(true);
            const countryId = userCountry?.id;
            const url = `v1/courses?price_sort=${filter?.value ?? ''}&country_id=${countryId}`;
            const resp = loggedIn ? await getAuthDataCall(url) : await getDataCall(url);
            if (resp.success) {
                setHasNextPage(true);
                setNextPage(resp.data.next_page_url);
                setLoading(false);
                setData(resp.data.data);
            }
            if (resp.data.current_page === resp.data.last_page) {
                setHasNextPage(false);
                return;
            }
        },
        [loggedIn, userCountry]
    );

    // filter by instructor
    async function getFilterDataByInstructor(filter) {
        const selectedSearch = filter.value;
        if (selectedSearch === null || selectedSearch === '') {
            setData(searchInstructor);
            return;
        }

        const filteredData = searchInstructor.filter((el) =>
            el?.instructors?.some((instructor) => instructor.id === selectedSearch)
        );

        setData(filteredData);
    }

    useEffect(() => {
        if (!loggedIn) {
            getTags('/v1/tags');
        }
    }, [loggedIn, getTags]);

    useEffect(() => {
        if (loggedIn && user) {
            if (location.state === undefined) {
                // All Courses
                getAllCourses(`/v1/courses?country_id=${user.country_id}`);
                return;
            } else {
                // Category Courses
                if (location.sub_category === undefined) {
                    getCourseByCategory(
                        `v1/courses?category_id=${location.state}&country_id=${user.country_id}`
                    );
                } else {
                    getCourseByCategory(
                        `v1/courses?category_id=${location.state}&sub_category_id=${location.sub_category}&country_id=${user.country_id}`
                    );
                }
                return;
            }
        }
    }, [user, location, getAllCourses, getCourseByCategory, loggedIn]);

    useEffect(() => {
        if (!loggedIn && userCountry) {
            const countryId = userCountry.id;

            if (location.state === undefined) {
                // All Courses
                if (countryId !== null) {
                    getAllCourses(`/v1/courses?country_id=${countryId}`);
                }
            } else {
                // Category Courses
                let url = `v1/courses?category_id=${location.state}`;
                if (location.sub_category) {
                    url += `&sub_category_id=${location.sub_category}`;
                }
                getCourseByCategory(`${url}&country_id=${countryId}`);
            }
        }
    }, [location, getCourseByCategory, getAllCourses, loggedIn, userCountry]);

    const customStyles = {
        padding: '5px 0px',
        borderRadius: '11px',
        borderCcolor: 'red',
        width: '100px',
    };
    return (
        <>
            {!loadingUser && !loading ? (
                <PageLayout me={user}>
                    <section className="mb_50 mt_50">
                        <div className="container">
                            <h2 className="page_title">
                                {location.state === undefined
                                    ? t('routes.allCourses')
                                    : type + ' ' + t('common.courses')}
                            </h2>
                            {location.state === undefined && (
                                <div className="row" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                                    <div className="col-lg-7 col-md-8 col-12">
                                        <div className="all_filters">
                                            <button
                                                className={`filter_btn ${tag === 0 ? 'btn_primary' : 'btn_primary_inverted'
                                                    }`}
                                                onClick={() => {
                                                    getAllCourses(`v1/courses?country_id=${userCountry.id}`);
                                                }}
                                            >
                                                {t('common.all')}
                                            </button>
                                            {tags.length > 0
                                                ? tags.map((item, key) => {
                                                    return (
                                                        <button
                                                            className={`filter_btn ${tag === item.id
                                                                ? 'btn_primary'
                                                                : 'btn_primary_inverted'
                                                                }`}
                                                            onClick={() => {
                                                                getFilterData('tag_id=' + item.id, item.id);
                                                                setHasNextPage(true);
                                                            }}
                                                            key={key}
                                                        >
                                                            {t('category.' + item.name, item.name)}
                                                        </button>
                                                    );
                                                })
                                                : ''}
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-4 col-12 d-lg-block d-md-block d-flex justify-content-center align-items-center flex-row flex-nowrap">
                                        <div className="sort_wrapper row flex-grow-1">
                                            <div className="col-md-6 col-12 px-1">
                                                <Select
                                                    name="form-field-name"
                                                    className="form-control"
                                                    value={priceFilter}
                                                    onChange={(selected) => {
                                                        setPriceFilter(selected);
                                                        getFilterDataBYPrice(selected);
                                                    }}
                                                    placeholder={t('common.select')}
                                                    options={options}
                                                    styles={customStyles}
                                                />
                                            </div>
                                            <div className="col-md-6 col-12 px-1">
                                                {instructors && instructors.length > 0 && (
                                                    <Select
                                                        name="form-field-name"
                                                        className="form-control"
                                                        onChange={(selected) => {
                                                            getFilterDataByInstructor(selected);
                                                        }}
                                                        placeholder={t('common.instructor')}
                                                        options={instructors}
                                                        styles={customStyles}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {data?.length >= 1 ? (
                                <div dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                                    <InfiniteScroll
                                        className="row"
                                        dataLength={data?.length} //This is important field to render the next data
                                        next={location.state === undefined ? fetchData : fetchCourseData}
                                        hasMore={hasNextPage}
                                        loader={<h4>Loading...</h4>}
                                    >
                                        {data?.map((course, index) => (
                                            <Card
                                                key={index}
                                                data={course}
                                                id={course?.id}
                                                category={course?.category?.name}
                                                title={course?.name}
                                                tutor={
                                                    course?.instructor?.first_name + ' ' + course?.instructor?.last_name
                                                }
                                                price={course?.is_free === false ? course?.course_sale : 'Free'}
                                                thumbnail={course?.course_image}
                                                isFree={course?.is_free}
                                                isWishlist={course?.is_wishlist}
                                                isPurchased={course?.is_purchased}
                                                translation={course?.translation}
                                                instructorsList={course?.instructors}
                                                product_id={course?.product_id}
                                            />
                                        ))}
                                    </InfiniteScroll>
                                    {hasNextPage ? (
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                width: 'fit-content',
                                                margin: 'auto',
                                            }}
                                        >
                                            <button
                                                className="btn_primary btn_ "
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                }}
                                                onClick={fetchCourseData}
                                            >
                                                <span>See more courses</span>
                                                <span>&darr;</span>
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            ) : (
                                <h1 style={{ textAlign: 'center', marginTop: '16px' }}>{t('common.comingSoon')}</h1>
                            )}
                        </div>
                    </section>
                </PageLayout>
            ) : (
                <Loader />
            )}
        </>
    );
}

export default withRouter(AllCourses);
